import { createFileRoute } from '@tanstack/react-router';
import { TreasuryPage } from '@/features/currency/treasury-page';

export const Route = createFileRoute('/_app/treasury')({
  component: TreasuryPage,
});
